import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../api/client";
import { applyTheme } from "../lib/colors";

interface SiteSettings {
  primaryColor: string;
  secondaryColor: string;
}

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  const { data } = useQuery({
    queryKey: ["site-settings"],
    queryFn: () => api<SiteSettings>("/settings"),
    staleTime: 1000 * 60 * 10,
  });

  useEffect(() => {
    if (data) applyTheme(data.primaryColor, data.secondaryColor);
  }, [data]);

  return <>{children}</>;
}
